import * as React from 'react'

export function useResizeObserver(containerRef: HTMLDivElement | null): {
  width: number
  height: number
} {
  const [size, setSize] = React.useState({
    width: containerRef?.getBoundingClientRect().width ?? 0,
    height: containerRef?.getBoundingClientRect().height ?? 0,
  })

  const updateSize = React.useCallback(() => {
    if (containerRef) {
      setSize({
        width: containerRef.getBoundingClientRect().width,
        height: containerRef.getBoundingClientRect().height,
      })
    }
  }, [containerRef])

  React.useEffect(() => {
    if (!containerRef) {
      return
    }

    const observer = new ResizeObserver(updateSize)
    observer.observe(containerRef)

    updateSize()

    return () => {
      observer.disconnect()
    }
  }, [containerRef, updateSize])

  return size
}

export function useWidthResizeObserver(containerRef: HTMLDivElement | null): number {
  return useResizeObserver(containerRef).width
}

export function useHeightResizeObserver(containerRef: HTMLDivElement | null): number {
  return useResizeObserver(containerRef).height
}
